type Scalar = string | number | boolean;

const includes = <T extends Scalar, U>(
  array: readonly T[],
  value: U
): value is T & U => {
  return (array as (T | U)[]).includes(value);
};

const exclude = <T extends Scalar, U extends Scalar | null | undefined>(
  array: readonly T[],
  value: U
): T[] => {
  return (array as (T | U)[]).filter((item: T | U): item is T => {
    return item !== value;
  });
};

const unique = <T extends Scalar>(array: T[]): T[] => {
  return Array.from(new Set(array));
};

const append = <T extends Scalar>(array1: T[], array2: T[]): T[] => {
  return unique([...array1, ...array2]);
};

const remove = <T extends Scalar>(array1: T[], array2: T[]): T[] => {
  return array1.filter((item: T): boolean => {
    return !array2.includes(item);
  });
};

const intersect = <T extends Scalar>(array1: T[], array2: T[]): T[] => {
  return array1.filter((item: T): boolean => {
    return array2.includes(item);
  });
};

export { includes, exclude, unique, append, remove, intersect };
